import React, { FC } from 'react';

import { useAccessibilityTrendsQuery } from '../../hooks/useAccessibilityTrendsQuery';

import { AccessibilityTrendsChart } from './AccessibilityTrendsChart';

export const AccessibilityTrendsChartContainer: FC = () => {
	const { data, isLoading, error } = useAccessibilityTrendsQuery();

	return (
		<AccessibilityTrendsChart
			data={data}
			isLoading={isLoading}
			error={error ? 'Failed to load accessibility trends data' : null}
			className="accessibility-trends-chart"
		/>
	);
};
